import React, { ReactNode } from 'react'

import { MarginProps, MaxWidthProps } from 'styled-system'

import { Text } from 'Components/UI'

type Props = MarginProps &
  MaxWidthProps & {
    centered?: boolean
    inverse?: boolean
    right?: boolean
    text: ReactNode
  }

function ContentBlockParagraph({
  centered,
  inverse,
  right,
  text,
  ...rest
}: Props) {
  return (
    <Text
      {...rest}
      center={centered}
      inverse={inverse}
      regular
      right={right}
      screen14
    >
      {text}
    </Text>
  )
}

export default ContentBlockParagraph
